import React, { memo, useState, useEffect } from 'react';
import { useEntitlements } from '../contexts/EntitlementContext';

function PaymentSuccess({ sessionId, onContinue }) {
  const { refresh } = useEntitlements();
  const [loaded, setLoaded] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Refresh entitlements after successful payment
    async function refreshData() {
      await refresh();
      setLoaded(true);
    }
    refreshData();
  }, [refresh]);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`game-over-overlay${visible ? ' game-over-visible' : ''}`} role="dialog" aria-label="Payment Successful">
      <div className="payment-success-card">
        <div className="payment-success-icon">&#10003;</div>
        <h2 className="payment-success-title">THANK YOU!</h2>
        <p className="payment-success-message">
          Your purchase was successful. Your new benefits are now active.
        </p>
        {!loaded && (
          <p className="payment-success-loading">Activating your benefits...</p>
        )}
        <button
          className="play-again-btn"
          onClick={onContinue}
          disabled={!loaded}
          autoFocus
        >
          {loaded ? 'CONTINUE' : 'LOADING...'}
        </button>
      </div>
    </div>
  );
}

export default memo(PaymentSuccess);
